import type { ReactElement } from "react";
import { CmtsWorkflowContainer } from "../../core/containers/domain/complaintsRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsWorkflowContainer runtime={props.runtime} />;
}

export default Component;
